import {useParams} from '@aboutyou/router';
import {getEntityIdFromRouteParam} from '@aboutyou/utils';

export const useProductIdFromSlug = (): number | undefined => {
  const {prefixedProductId, productId: legacySoldOutProductId} = useParams<{
    prefixedProductId?: string;
    productId?: string;
  }>();

  const slug = prefixedProductId || legacySoldOutProductId;
  const productId = getEntityIdFromRouteParam(slug);

  return productId ? Number(productId) : undefined;
};
